// Lib
import React, { useCallback } from 'react';
import Immutable from 'immutable';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { moveElementsToTrash } from '../../../../../element/actions/elementShortcutActions';
import { ToolTypeSettings, ToolbarSettings } from '../../../toolbarTypes';
import { removeLabelFromElements } from '../../../../../element/labels/elementLabelActions';
import { getSelectedLabelId } from '../../../../../element/labels/labelSelectors';
import { deselectAllElements } from '../../../../../element/selection/selectionActions';

type RemoveElementToolProps = {
    currentBoardId: string;
    selectedElements: Immutable.List<ImMNElement>;
    toolSettings?: ToolbarSettings;
};

const RemoveElementTool: React.FC<RemoveElementToolProps> = (props) => {
    const { selectedElements, currentBoardId, toolSettings } = props;
    const dispatch = useDispatch();
    const selectedLabelId = useSelector(getSelectedLabelId);

    const dispatchMoveElementsToTrash = useCallback(
        () => dispatch(moveElementsToTrash({ elements: selectedElements, currentBoardId })),
        [selectedElements, currentBoardId],
    );

    const dispatchRemoveLabelFromElement = useCallback(() => {
        if (!selectedLabelId) return;

        dispatch(removeLabelFromElements(selectedElements, selectedLabelId));
        dispatch(deselectAllElements());
    }, [selectedElements, selectedLabelId]);

    const onClick = useCallback(() => {
        const isLabel = (toolSettings as ToolTypeSettings)?.isLabel;
        if (isLabel) {
            dispatchRemoveLabelFromElement();
            return;
        }

        dispatchMoveElementsToTrash();
    }, [toolSettings, dispatchRemoveLabelFromElement, dispatchMoveElementsToTrash]);

    return (
        <div className="RemoveElementTool">
            <ToolbarTool {...props} onClick={onClick}>
                <Icon name="toolbar-move-to-trash" />
            </ToolbarTool>
        </div>
    );
};

export default RemoveElementTool;
